export default function Table({children}) {
    return (
        <table className=" table table-striped">
            {children}
        </table>
    );
};
